import {
  CdkDragDrop,
  CdkDragMove,
  DragDropModule,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogActions,
  MatDialogTitle,
} from '@angular/material/dialog';
import { DataService } from '@data/data.service';
import { InputModule } from '@input/input.module';
import { NotificationService } from '@notification/notification.service';
import { myFormatDate } from '@util/date-utils';
import { ensureArray } from '@util/utils';
import { DocumentProgressBarComponent } from '../document-progress-bar/document-progress-bar.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-merge-documents-dialog',
  standalone: true,
  imports: [
    CommonModule,
    DragDropModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogContent,
    MatDialogActions,
    MatDialogTitle,
    InputModule,
    DocumentProgressBarComponent,
  ],
  templateUrl: './merge-documents-dialog.component.html',
})
export class MergeDocumentsDialogComponent implements OnInit {
  allSelected = false;

  fileName = '';

  files: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<MergeDocumentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private dataService: DataService,
    private notificationService: NotificationService
  ) {
    const files = ensureArray(this.dialogData.files);
    const d = new Date();
    const dateStr = myFormatDate(d, 'DD.MM.YYYY_HH.mm.ss');

    console.log('Files:', files);

    this.fileName = 'Zusammenfassung_' + dateStr;

    files.forEach((item: any) => {
      item.merge = !!item.canmerge;
    });

    this.allSelected = files.every((item: any) => {
      return item.merge;
    });

    this.files = files;
  }

  ngOnInit(): void {}

  close() {
    this.dialogRef.close(null);
  }

  isMerging = false;

  save() {
    const ids = this.files
      .filter((item: any) => {
        return item.merge;
      })
      .map((item: any) => {
        return item.id;
      });

    const fn = this.fileName.trim();
    if (!fn) {
      this.notificationService.showErrors(['Dokumentname ist leer']);
      return;
    }

    if (!ids.length) {
      this.notificationService.showErrors(['Keine Dokumente ausgewählt']);
      return;
    }

    const requestData: any = {
      ids: ids,
      filename: this.fileName,
    };
    const url = '/montage/documents/' + this.dialogData.orderId + '/merge';

    this.isMerging = true;

    this.dataService
      .post(url, requestData, {
        headers: {},
      })
      .subscribe((res: any) => {
        const result = res?.result;

        this.isMerging = false;

        if (result?.success) {
          const msg = result.msg || 'Datei erfolgreich gespeichert';
          this.notificationService.showSuccess(msg);
          this.dialogRef.close({
            docId: result.id,
          });
        } else {
          const errors: any = [];
          if (result?.error) {
            errors.push(result?.error);
          } else {
            errors.push('Unbekannter Fehler beim Speichern der Datei');
          }

          this.notificationService.showErrors(errors);
        }
      });
  }

  selectAllDocuments($event: any) {
    this.allSelected = $event.checked;

    this.files.forEach((item: any) => {
      item.merge = !!item.canmerge && this.allSelected;
    });
  }

  selectDocument($event: any, item: any) {
    item.merge = !!item.canmerge && $event.checked;

    this.allSelected = this.files.every((item:any)=> {
      return !!item.merge;
    });
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.files, event.previousIndex, event.currentIndex);
  }

  dragMoved($event: CdkDragMove<any>) {
    //console.log('Drag:', $event);
  }
}
